/** @typedef {'CREATED' | 'CLICKED' | 'SENT' | 'OPENED' | 'RECEIVED' | 'ERROR'} EmailStatusEnum */
const EMAIL_STATUS = {
  ERROR: 'ERROR',
  CREATED: 'CREATED',
  CLICKED: 'CLICKED',
  SENT: 'SENT',
  OPENED: 'OPENED',
  RECEIVED: 'RECEIVED',
};

export const EMAIL_STATUS_ORDERED = [
  EMAIL_STATUS.CREATED,
  EMAIL_STATUS.SENT,
  EMAIL_STATUS.RECEIVED,
  EMAIL_STATUS.ERROR,
  EMAIL_STATUS.OPENED,
  EMAIL_STATUS.CLICKED,
];

export const DRAWER_DETAILS_TARGET = 'drawer-details';

export const DEFAULT_SORT = ['status,desc', 'insights.email.openedOn,desc'];

export const DEFAULT_BULK_SORT = ['insights,EMAIL,answeredOn,desc'];

export const BULK_FILTER_KEY = 'CAMPAIGN/DETAILS/BULK_MODAL_FILTERS';

export const CAMPAIGN_FILE_EVENT_ENUM = {
  ANSWERED: 'ANSWERED',
  BOUNCED: 'BOUNCED',
  CLICKED: 'CLICKED',
  COMPLAINT: 'COMPLAINT',
  CREATED: 'CREATED',
  OPENED: 'OPENED',
  RECEIVED: 'RECEIVED',
  SENT: 'SENT',
};
